import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from '../User.scss';
import icon from 'styles/icons/document-icon.scss';


const DocumentType = ({docType}) => {
    return (
        <div className={styles.row}>
            <span className={styles.title}>
                { docType.displayName }
            </span>
            <span className={styles.description}>
                { docType.description }
            </span>
        </div>
    );
};

export class UserDocumentTypes extends Component {

    render() {
        const { documentTypes } = this.props;

        return (
            <div className={styles.container} data-cy="UserDocumentTypes">
                <header className={styles.header}>
                    <span className={icon.documentTypeIcon}></span>
                    <span className={styles.title}>Document Types</span>
                </header>
                <section className={styles.listWrapper} data-cy="UserDocumentTypes-section">
                    { documentTypes.map((docType, index) => {
                        return <DocumentType docType={docType} key={index + docType.id} />;
                    })}
                </section>
            </div>
        );
    }

}

UserDocumentTypes.propTypes = {
    documentTypes: PropTypes.array.isRequired
};

export default UserDocumentTypes;
